<template>
  <div class="app flex-row align-items-center" style="background-color: rgb(246,246,246) !important">
    <div class="container">
      <div class="login">
        <div class="wrapper wrapper-login bg_img">
          <div class="container container-login">
            <div class="bg_icon">
              <img src="/f1/assets/img/login_icon.png" class="mx-auto d-block ">
            </div>
            <h3 class="text-center login_tit">로그인</h3>
            <p class="font_20 font-weight-bold text-center">{{custom && custom.slogan ? custom.slogan : 'F1-UWSS'}}</p>
            <h3 class="text-center login_sub">로그인을 하면 다양한 서비스를 이용할 수 있어요.</h3>
            <!-- <p class="text-muted">Sign into your account
              <b-button variant="link" @click="reset()" class="float-right px-0">Forget password or OTP ?</b-button>
            </p> -->
            <div class="login-form">
              <div class="form-group mb-1">
                <input type="text" class="form-control" placeholder="Email" v-model="m.username" @keyup.enter="login()">
              </div>
              <div class="form-group mb-1">
                <input type="password" class="form-control" placeholder="Password" v-model="m.password" @keyup.enter="login()">
              </div>
              <transition name="fade" :duration="3000">
                <b-input-group class="mb-3" v-show="require_otp">
                  <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                  <input type="text" class="form-control" placeholder="OTP Code (Option)" v-model="m.otp" @keyup.enter="login()">
                </b-input-group>
              </transition>
              <div class="form-group py-2">
                <div class="custom-control custom-radio">
                  <!-- <b-checkbox class="m-0 font_16" v-model="save_username">Remember me</b-checkbox> -->
                  <input type="checkbox" class="custom-control-input" id="customRadio" name="example1" v-model="save_username">
                  <label class="custom-control-label m-0 font_16" for="customRadio">아이디 저장</label>
                </div>
                <div class="custom-control custom-radio">
                  <Language />
                </div>
              </div>
              <div class="form-group form-action-d-flex">
                  <b-button variant="primary" class="btn btn-primary btn-lg btn-block" @click="login()">로그인</b-button>
              </div>
              <div class="login-account font_16">
                <b-button variant="link" v-if="custom" class="link text-secondary" disabled>v{{ custom.version }}</b-button>
                <span class="px-1 dot">·</span>
                <b-button variant="link" @click="reset()" class="link text-secondary">비밀번호 또는 OTP 를 잊어버렸나요?</b-button>
              </div>
            </div>
            <b-col class="bg_logo">
                <img src="/f1/assets/img/F1-uwss.png" class="mx-auto d-block" height="30" alt="">
            </b-col>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>